import TableAction from "../../components/strategyProject/tabs/TabResults/TableAction/TableAction";
import {NavLink} from "react-router-dom";
import {Button, Image} from "react-bootstrap";
import style from "../../components/strategyProject/tabs/TabResults/TabResults.module.less";
import React from "react";
import {getStrategyPermissions, isAdmin} from "../../services/rolesSvc";
import fromProjectMilestoneIcon from '../../../img/icons/from-project-milestone-icon.svg'
import { Tooltip } from "@mui/material";

export const status = {
    isCreating:'isCreating',
    inProgress:'inProgress',
    returned: 'returned',
    onProjOffice: 'onProjOffice',
    approved: 'approved',
    declined: 'declined',
    achieved: 'achieved'
};
export const statusForFilter = {
    inProgress:'На исполнении',
    returned: 'На исполнении', //TODO fix status returned
    onProjOffice: 'В Проектном офисе',
    approved: 'Одобрен',
    declined: 'Отклонен',
    achieved: 'Достигнут'
};
export const statusForFilterRu = {
    'На исполнении':[status.inProgress, status.returned],
    'В Проектном офисе':[status.onProjOffice],
    'Одобрен':[status.approved],
    'Отклонен':[status.declined],
    'Достигнут':[status.achieved]
}

export const status_ru = {
    isCreating:'На заполнении',
    inProgress: 'На исполнении',
    returned: 'На исполнении',
    onProjOffice: 'В Проектном офисе',
    approved: 'Одобрен',
    declined: 'Отклонен',
    achieved: 'Достигнут'
};

export const status_full = {
    isCreating:{ key: status.isCreating, label: status_ru.isCreating, bg: 'primary' },
    inProgress: { key: status.inProgress, label: status_ru.inProgress, bg: 'secondary' },
    returned: { key: status.returned, label: status_ru.returned, bg: 'secondary' },
    approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
    declined: { key: status.declined, label: status_ru.declined, bg: 'danger' },
    onProjOffice: { key: status.onProjOffice, label: status_ru.onProjOffice, bg: 'warning' },
    achieved: {key: status.achieved, label: status_ru.achieved, bg: 'success'}
};


export const actionSwitcher = (props,userCtx,requests,stratId,resultId=null,setCurrentId,ref) => {
    const id = !resultId ? `${props.data.id}-0` : `${resultId}-${props.data.id}`
    if(props.data.fromProjects){
        return (<Tooltip title={'Веха из проекта'}>
                <Image src={fromProjectMilestoneIcon} style={{width: 32, height: 26}}/>
            </Tooltip>)
    }
    if(isAdmin(userCtx)){
        switch (props.data.status){
            case status.onProjOffice:
                return(
                    <TableAction width={'300px'} data={props.data}>
                                <Button
                                 className={style.actionTableButton}
                                 variant="outline-primary"
                                 onClick={() => {
                                    requests.changeStatus(props.data.id, 'achieve')
                                    setCurrentId(props.data.id,'achieve',props.data)
                                 }}
                                >
                                    Зафиксировать достижение результата
                                </Button>
                                <Button className={style.actionTableButton}  onClick={()=>{
                                    // props.data.comment="123"
                                    // store.strategies.changeResultsComment(el)
                                    requests.changeStatus(props.data.id, 'approve')
                                    setCurrentId(props.data.id,'approve',props.data)
                                    // requests.changeStatus(props.data.id,'approve')
                                }} variant={"outline-success"}>Одобрить</Button>
                                <Button className={style.actionTableButton}  onClick={()=>{
                                    setCurrentId(props.data.id,'decline',props.data)
                                    // requests.changeStatus(props.data.id,'decline',{'comment':sto})
                                }} variant={"outline-danger"}>Отклонить</Button>
                                <Button className={style.actionTableButton} onClick={()=>{
                                    // setCurrentId(id)
                                    setCurrentId(props.data.id,'return',props.data)
                                    // requests.changeStatus(props.data.id,'return',props.data)
                                }}  variant={"outline-warning"}>На доработку</Button>
                            <NavLink style={{width:"100%"}} to={`/strats/${stratId}/${id}/edit`}>
                                <Button style={{width:"100%"}} className={style.actionTableButton} variant={"primary"}>Редактировать</Button>
                            </NavLink>
                    </TableAction>
                )
            case status.inProgress :{
                return(
                    <TableAction width={'300px'} data={props.data}>
                        <NavLink to={`/strats/${stratId}/${id}/edit`}>
                            <Button style={{width:"100%"}} variant={"primary"} >Заполнить факт</Button>
                        </NavLink>
                    </TableAction>
                )}
            case status.returned : {
                return (
                    <TableAction width={'300px'} data={props.data}>
                            <NavLink to={`/strats/${stratId}/${id}/edit`}>
                                <Button style={{width:"100%"}} variant={"primary"}>Редактировать</Button>
                            </NavLink>
                    </TableAction>
                )
            }
            case status.declined : {
                return (
                    <TableAction width={'300px'} data={props.data}>
                        <NavLink to={`/strats/${stratId}/${id}/edit`}>
                            <Button style={{width:"100%"}} variant={"primary"}>Редактировать</Button>
                        </NavLink>
                    </TableAction>
                )
            }
            case status.approved : {
                return (
                    <TableAction width={'300px'} data={props.data}>
                        <NavLink to={`/strats/${stratId}/${id}/edit`}>
                            <Button style={{width:"100%"}} variant={"primary"}>Редактировать</Button>
                        </NavLink>
                    </TableAction>
                )
            }
            case status.achieved : {
                return (
                    <TableAction width={'300px'} data={props.data}>
                        <NavLink to={`/strats/${stratId}/${id}/edit`}>
                            <Button style={{width:"100%"}} variant={"primary"}>Редактировать</Button>
                        </NavLink>
                    </TableAction>
                )
            }
            default:return(<></>)
        }
    }
    if(!!getStrategyPermissions(userCtx,stratId).role){
        if(props.data.status === status.inProgress || props.data.status === status.returned ){
            switch (!!props.data?.result){
                case (false):
                    return (
                        <TableAction width={'300px'} data={props.data}>
                            <NavLink to={`/strats/${stratId}/${id}/edit`}>
                                <Button style={{width:"100%"}} className={style.actionButtonWithoutGroup}  variant={"primary"} >Заполнить факт</Button>
                            </NavLink>
                        </TableAction>
                    )
                case (true):
                    return (
                        <TableAction width={'300px'} data={props.data}>
                            <NavLink to={`/strats/${stratId}/${id}/edit`}>
                                <Button style={{width:"100%"}} className={style.actionButtonWithoutGroup}  variant={"primary"} >Редактировать</Button>
                            </NavLink>
                        </TableAction>
                    )
            }
        }
        else return <></>
    }
    return null
}


export function filterPersonWithProjects(person, projects){
    let inProjectsWithProjId = false;
    let notContainsWithoutProjId = !person.projId;
    for(const proj of projects){
        if(person.projId && proj.id === person.projId){
            inProjectsWithProjId = true;
        }
        if(!person.projId && proj.head && 
            proj.head[typeof proj.head.id === 'string' ? 'id' : proj.head.userId ? 'userId' : 'employeeId'] === person[typeof person.id === 'string' ? 'id' : person.userId ? 'userId' : 'employeeId']
        ){
            notContainsWithoutProjId = false;
        }
    }
    return {inProjectsWithProjId, notContainsWithoutProjId}
}
